import Base from 'app/models/base';
import TrackingDetails from 'app/collections/tracking_details';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('trackers'),
  rootKey: 'tracker',
  nestedModels: {
    tracking_details: TrackingDetails,
  },
});



// WEBPACK FOOTER //
// ./app/models/tracker.js